export default "__VITE_ASSET__d2efc18b__"